import { render, staticRenderFns } from "./ModalBranchEdit.vue?vue&type=template&id=125c5644"
import script from "./ModalBranchEdit.vue?vue&type=script&lang=js"
export * from "./ModalBranchEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports